import { ClassificaDTO } from "../classificaDTO";
import { MetadatiProtocolloGescorDTO } from "./metadati-protocollo-gescorDTO";
import { ClassificaGescorDTO } from "./classifica-gescorDTO";

export class MetadatiProtocolloEstesiDTO {
  idDocumentoPrimario: string;

  metadatiProtocollo: MetadatiProtocolloGescorDTO;

  isPartenza: boolean;

  isPartenzaMista: boolean;

  classifica: ClassificaGescorDTO[];
}
